import "./src/styles/global.css";
import React from "react";
import { UserProvider } from "./src/components/contexts/UserContext";

export const wrapRootElement = ({ element }) => (
  <UserProvider>{element}</UserProvider>
);
